/**
 * Admin container
 */
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import complianceActions from './actions';
import {
  loadingSelector,
  errorSelector,
  userSelector,
  countSelector,
} from './selectors';
import appActions from '../App/actions';
import ComplianceConsole from '../../Components/Compliance/Compliance';

/**
 * Admin properties to be provided to the compliance console component

 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  loading: loadingSelector(state),
  error: errorSelector(state),
  users: userSelector(state),
  count: countSelector(state),
});

/**
 * Actions to be dispatched
 *
 * @param {function} dispatch function to dispatch compliance actions
 */
const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(appActions.logout()),
  fetchUsers: (search) => dispatch(complianceActions.fetchUsers(search)),
});

/**
 * Connects compliance state to the Admin Console component

 * @param {object} mapStateToProps compliance data object to become props for the Admin component
 * @param {object} mapDispatchToProps compliance actions to be dispatched to reducer
 */
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ComplianceConsole),
);
